import { useMutation, useQueryClient } from '@tanstack/react-query'
import { taskKeys } from '@/entities/task'
import { apiRequest } from '@/shared/api'

export interface CreateTaskVars {
  title: string
  due?: string
  // Блокирует перенос проекта на следующий этап; бэк игнорирует у заказчика.
  blocking?: boolean
}

export function useCreateTask(projectId: string) {
  const qc = useQueryClient()
  return useMutation({
    // Бэк принимает project_id из пути (POST /projects/{projectId}/tasks), не из тела.
    mutationFn: (vars: CreateTaskVars) =>
      apiRequest({ method: 'POST', url: `/projects/${projectId}/tasks`, body: { ...vars } }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: taskKeys.byProject(projectId) })
      void qc.invalidateQueries({ queryKey: taskKeys.lists })
    },
  })
}
